export const PlatformAdmin = 'platform_admin'
export const SiteAdmin = 'site_admin'
export const HubAdmin = 'hub_admin'
export const ProjectAdmin = 'project_admin'
export const Participant = 'participant'
export const BlockedUser = 'blocked_user'
export const AllAdmins = 'all_admins'
export const PROJECT_ADMIN_TYPE = 'ProjectAdmin'
